import { render } from "./AudiencesList.vue?vue&type=template&id=fa818ad4"
import script from "./AudiencesList.vue?vue&type=script&lang=js"
export * from "./AudiencesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__